function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef } from "react";
import cls from "classnames";
import { InfiniteScroll } from "antd-mobile";
import { createNamespace, Empty, Loading } from "@firefly/fly-kda";
import "./style/index.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var _createNamespace = createNamespace("infinite-list"),
  _createNamespace2 = _slicedToArray(_createNamespace, 1),
  bem = _createNamespace2[0];
export function InfiniteList(props) {
  var className = props.className,
    style = props.style,
    height = props.height,
    isLoading = props.isLoading,
    isFetching = props.isFetching,
    dataSource = props.dataSource,
    _placeholder = props.placeholder,
    empty = props.empty,
    error = props.error,
    hasMore = props.hasMore,
    _loadMore = props.loadMore,
    children = props.children;
  var scrollContainerRef = useRef(null);
  function render(node) {
    if (typeof node === 'function') {
      return node();
    }
    return node;
  }
  function renderPlaceholder() {
    if (_placeholder) {
      return _placeholder;
    }
    if (isLoading) {
      if (isFetching !== false) {
        return /*#__PURE__*/_jsx("div", {
          className: cls(bem("placeholder")),
          children: /*#__PURE__*/_jsx(Loading, {
            direction: "horizontal",
            tip: "加载中"
          })
        });
      }
    }
    if (error) {
      return render(error);
    }
    if (dataSource) {
      if (dataSource.length === 0) {
        if (empty) {
          return render(empty);
        }
        return /*#__PURE__*/_jsx(Empty, {
          className: cls(bem("empty")),
          description: ""
        });
      }
    }
    return null;
  }
  var placeholder = renderPlaceholder();
  function renderContent() {
    if (dataSource) {
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [children(dataSource), /*#__PURE__*/_jsx(InfiniteScroll, {
          hasMore: hasMore,
          threshold: 250,
          loadMore: function loadMore(isRetry) {
            return _loadMore(isRetry);
          }
          // threshold={30}
        })]
      });
    }
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: cls(className, bem(_defineProperty({}, "has-placeholder", !!placeholder))),
    style: _objectSpread({
      height: height
    }, style),
    ref: scrollContainerRef,
    children: placeholder ? placeholder : renderContent()
  });
}